module.exports = __webpack_public_path__ + "static/media/img@2x.60ce2e24.webp";